import React, { useState } from "react";
import { Grid, Typography } from "@material-ui/core";
import moment from "moment";

import { Card, CardContent } from "../../components/Card";
import Table from "../../components/Table";
import Button from "../../components/Button";

export default function SendRecordTable() {
  const datatest = [{}];

  return (
    <Card>
      <CardContent>
        <Grid container spacing={1}>
          <Grid item sm={12}>
            <Table
              data={datatest}
              tableWidth={2}
              header={[
                "序號",
                "發送日期",
                "消費點數",
                "門號",
                "簡訊主旨",
                "簡訊內容",
                "發送狀態",
              ]}
              columns={[]}
              onPress={(item) => {}}
            />
          </Grid>
          <Grid item container justify="flex-end">
            <Typography>{"總計消費點數:" + "點"}</Typography>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}
